import { USER_MANAGEMENT_TABLE_COLUMN_CLASSES } from './constants';

import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { USER_MANAGEMENT_ROW_TEST_IDS } from '@/constants/data-testids';

import { TableCell, TableRow } from '../Table/Table';

export const UserManagementRowSkeleton = () => {
  return (
    <TableRow data-testid={USER_MANAGEMENT_ROW_TEST_IDS.SKELETON}>
      <TableCell className={USER_MANAGEMENT_TABLE_COLUMN_CLASSES.name}>
        <div className="flex min-w-0 items-center gap-2 max-w-[220px]">
          <Skeleton className="size-8 rounded-full shrink-0" />
          <div className="w-full flex flex-col gap-1.5 min-w-0">
            <Skeleton className="h-[14px] w-full" />
            <Skeleton className="h-[14px] w-2/3" />
          </div>
        </div>
      </TableCell>
      <TableCell className={USER_MANAGEMENT_TABLE_COLUMN_CLASSES.department}>
        <Skeleton className="h-[14px] w-full max-w-[120px]" />
      </TableCell>
      <TableCell className={USER_MANAGEMENT_TABLE_COLUMN_CLASSES.role}>
        <Skeleton className="h-[14px] w-full max-w-[120px]" />
      </TableCell>
      <TableCell className={USER_MANAGEMENT_TABLE_COLUMN_CLASSES.lastActive}>
        <Skeleton className="h-[14px] w-full max-w-[80px]" />
      </TableCell>
      <TableCell className={USER_MANAGEMENT_TABLE_COLUMN_CLASSES.actions}>
        <Skeleton className="h-8 w-8 rounded-[6px] mx-auto" />
      </TableCell>
    </TableRow>
  );
};
